import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getDate } from "../../../helpers/TimeDate";
import Loder from "../../loder";
import { UTCtoLocalConverter } from "../../../helpers/TimeDate";
import { PausePlan, ResumePlan } from "../../../redux/actions/PlanAction";
import { useSnackbar } from "react-simple-snackbar";
import { Tab, Nav, Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Subscription from "../components/Subscription";

function SubscriptionModal(props) {
  const useHistorys = useHistory();
  const history = useSelector((state) => state.PlanReducer.planHistory);
  const his = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [status, setStatus] = useState();
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  console.log(time_zone);
  // const [pausePeriod,setPausePeriod] = useState();
  const dispatch = useDispatch();

  function monthDiff(d1, d2) {
    var months;
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months <= 0 ? 0 : months + " month";
  }

  console.log(history);
  const Pause = (data, pausePeriod) => {
    const datas = {
      learnerId: data.learner._id,
      // subscriptionId: data._id,
      pausePeriod: pausePeriod,
      timezone: time_zone.timezone,
      // status:"Paused"
    };
    const onSuccess = () => {
      his.push("/dashboard");
      window.location.reload();
      his.push("/dashboard");
    };
    const onError = (msg) => {
      openSnackbar(msg);
    };
    dispatch(PausePlan(datas, onSuccess, onError));
  };

  const Resume = (data) => {
    const datas = {
      learnerId: data.learner._id,
      // subscriptionId: data._id,
      timezone: "Asia/Calcutta",
      // status:"Running"
    };
    const onSuccess = () => {
      his.push("/dashboard");
      window.location.reload();
      his.push("/dashboard");
    };
    const onError = () => {
      alert("Something went wrong !!");
    };
    dispatch(ResumePlan(datas, onSuccess, onError));
  };

  return (
    <div className="learner_account">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="sub"
      >
        <Modal.Body className="profile_modal_content">
          <Subscription/>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default SubscriptionModal;
